import { types } from 'mobx-state-tree';

const CheckoutPageModule = {
  CART_MODULE: 'CART_MODULE',
  CUSTOMER_INFO_MODULE: 'CUSTOMER_INFO_MODULE',
  SHIPPING_INFO_MODULE: 'SHIPPING_INFO_MODULE',
  PAYMENT_METHOD_MODULE: 'PAYMENT_METHOD_MODULE',
  SHIPPING_METHOD_MODULE: 'SHIPPING_METHOD_MODULE',
  SUMMARY_MODULE: 'SUMMARY_MODULE',
};

export default CheckoutPageModule;

export const CheckoutPageModuleType = types.enumeration(
  'CheckoutPageModule',
  Object.values(CheckoutPageModule)
);
